import {useTranslation} from '@aboutyou/i18n';
import {COLORS, Collapsible, LinkSections, Text} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React, {useState} from 'react';

export const GroupedSections = ({
  groupedSections,
}: {
  groupedSections: React.ComponentProps<typeof LinkSections>['linkGroups'];
}) => {
  const [label, setLabel] = useState<string | null>(null);
  const {t} = useTranslation();

  if (!groupedSections.length) {
    return null;
  }

  return (
    <Collapsible
      openerContent={<Opener>{label}</Opener>}
      bodyContent={
        <StyledLinkSections
          linkGroups={groupedSections}
          testId="groupedSectionLinks"
        />
      }
      onChange={isOpen => setLabel(isOpen ? '' : t('More'))}
      startCollapsed={false}
      collapseOnClient={true}
      minHeight={150}
    />
  );
};

const Opener = styled(Text)`
  color: ${COLORS.Grey1};
  border-bottom: solid 1px ${COLORS.Grey1};
  cursor: pointer;
`;

const StyledLinkSections = styled(LinkSections)`
  flex-direction: column;
  padding: 1.5rem 1.5rem 0;
`;
